import {
  RefundOfferCreationDetailsDto,
  RefundOfferCreationDetailsModel,
  RefundOfferCurrencyConversionDto,
  RefundOfferCurrencyConversionModel,
  RefundOfferEstimateDto,
  RefundOfferEstimateModel,
  RefundOfferIdDto,
  RefundOfferIdModel,
} from '../types/refund-offer'
import { transformCurrencyAmountDto } from './currency-amount'

export const transformRefundOfferCreationDetailsDto = (
  refundOfferCreationDetails: RefundOfferCreationDetailsDto,
): RefundOfferCreationDetailsModel => ({
  minAmount: transformCurrencyAmountDto(refundOfferCreationDetails.min_amount),
  maxAmount: transformCurrencyAmountDto(refundOfferCreationDetails.max_amount),
})

export const transformRefundOfferIdDto = ({
  refund_offer_id,
}: RefundOfferIdDto): RefundOfferIdModel => ({
  refundOfferId: refund_offer_id,
})

export const transformRefundOfferEstimateCurrencyConversionDto = (
  currencyConversion: RefundOfferCurrencyConversionDto,
): RefundOfferCurrencyConversionModel => ({
  details: {
    refundOffer: transformCurrencyAmountDto(currencyConversion.details.refund_offer),
  },
  exchange: {
    baseRate: transformCurrencyAmountDto(currencyConversion.exchange.base_rate),
    exchangeRate: transformCurrencyAmountDto(currencyConversion.exchange.exchange_rate),
  },
  markup: {
    rate: currencyConversion.markup.rate,
    provider: currencyConversion.markup.provider,
  },
})

export const transformRefundOfferEstimateDto = (
  refundOfferEstimate: RefundOfferEstimateDto,
): RefundOfferEstimateModel => ({
  refundOffer: transformCurrencyAmountDto(refundOfferEstimate.refund_offer),
  buyerProtectionFee: transformCurrencyAmountDto(refundOfferEstimate.buyer_protection_fee),
  totalRefund: transformCurrencyAmountDto(refundOfferEstimate.total_refund),
  currencyConversion: refundOfferEstimate.currency_conversion
    ? transformRefundOfferEstimateCurrencyConversionDto(refundOfferEstimate.currency_conversion)
    : null,
})
